import React from 'react';
import {
    Datagrid,
    DateField,
    ReferenceManyField,
    TextField,
    Pagination,
    useListContext,
} from 'react-admin';

import UserReferenceField from '../components/UserReferenceField';
import Revision from './Revision';

const DatagridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total History Records: {total || 0}
                </div>
            )}
            <Datagrid>
                <TextField source="serial" sortable={false} />
                <DateField
                    locales="en-IN"
                    label="Date"
                    source="createdAt"
                    showTime
                />

                <UserReferenceField label="User" link={false} />
                <TextField source="model" sortable={false} />

                <Revision />
            </Datagrid>
            <Pagination />
        </>
    );
};

const History = props => {
    const { model, documentId } = props;

    return (
        <ReferenceManyField
            {...props}
            filter={{ model, documentId }}
            sort={{ field: 'createdAt', order: 'DESC' }}
            reference="revisions"
            target="documentId"
            perPage={25}
        >
            <DatagridWithTotal />
        </ReferenceManyField>
    );
};

export default History;
